/* Deal 22 – product page "Order now" button. If the COD form app is installed, its own button is used instead and ours stays hidden, so the two never fight over the same form. */
(function(){
  if(window.__d22bn) return; window.__d22bn=true;
  function appActive(){return !!document.querySelector('script[src*="releasit" i],[id*="releasit" i],[class*="releasit" i],[data-releasit]')}
  function hideIfApp(){
    if(!appActive()) return;
    document.querySelectorAll('[data-d22-buynow]').forEach(function(b){b.style.display='none'});
  }
  hideIfApp(); window.addEventListener('load',function(){hideIfApp();setTimeout(hideIfApp,1200)});
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-d22-buynow]'); if(!btn||btn.disabled) return;
    if(appActive()) return;
    var pf=btn.closest('product-form'), form=pf&&pf.querySelector('form'); if(!form) return;
    var fd=new FormData(form); if(!fd.get('id')) return;
    var wrap=pf.querySelector('.product-form__error-message-wrapper'), msg=pf.querySelector('.product-form__error-message');
    if(wrap) wrap.hidden=true;
    btn.classList.add('loading'); btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',body:fd,headers:{'X-Requested-With':'XMLHttpRequest',Accept:'application/json'}})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok) throw new Error(res.j.description||res.j.message||'Could not add this item.');
        window.location.href='/checkout';
      })
      .catch(function(err){
        if(msg) msg.textContent=err.message; if(wrap) wrap.hidden=false;
        btn.classList.remove('loading'); btn.disabled=false;
      });
  });
})();
